import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../common/components/Icon/Icon";
import { LegalAgreementsSnapshot } from "../types/orderApiTypes";

interface OrderAgreementsSnapshotProps {
  snapshot?: LegalAgreementsSnapshot;
}

/**
 * Renders the permanent snapshots of legal agreements accepted at the time of purchase.
 */
const OrderAgreementsSnapshot: React.FC<OrderAgreementsSnapshotProps> = ({
  snapshot,
}) => {
  const { t } = useTranslation();

  // Guard: If there are no snapshots, render nothing
  if (!snapshot?.preliminaryHtml && !snapshot?.salesHtml) {
    return null;
  }

  return (
    <div className="order-page__agreements">
      <h3 className="order-page__agreements-title">
        {t("legalAgreements.modalTitle", "Sales Agreements")}
      </h3>
      <p className="order-page__agreements-notice">
        {t(
          "orderPage.agreementsSnapshotNotice",
          "These are the permanent copies of the agreements accepted at the time of order."
        )}
      </p>

      <div className="order-page__agreements-list">
        {snapshot.preliminaryHtml && (
          <details className="order-page__agreement-item">
            <summary>
              {t(
                "legalAgreements.preliminaryForm",
                "Preliminary Information Form"
              )}
              <Icon iconName="chevron-down" />
            </summary>
            <div
              className="order-page__agreement-content wysiwyg-content"
              dangerouslySetInnerHTML={{
                __html: snapshot.preliminaryHtml,
              }}
            />
          </details>
        )}

        {snapshot.salesHtml && (
          <details className="order-page__agreement-item">
            <summary>
              {t("legalAgreements.salesAgreement", "Distance Sales Agreement")}
              <Icon iconName="chevron-down" />
            </summary>
            <div
              className="order-page__agreement-content wysiwyg-content"
              dangerouslySetInnerHTML={{
                __html: snapshot.salesHtml,
              }}
            />
          </details>
        )}
      </div>
    </div>
  );
};

export default OrderAgreementsSnapshot;
